var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "option-container" },
    [
      _c(
        "v-btn",
        {
          key: _vm.profile.slug,
          staticClass: "profile-option-btn no-padding no-margin",
          class: { active: _vm.rootProfileActive },
          attrs: {
            flat: "",
            title: _vm.getProfileTitle(_vm.profile.slug),
            color: _vm.rootProfileActive ? "primary" : "dark"
          },
          on: {
            click: function($event) {
              return _vm.profileSelected(_vm.profile.slug)
            }
          }
        },
        [
          _c("v-icon", { attrs: { large: "" } }, [
            _vm._v(_vm._s(_vm.profile.icon))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm.profile.vehicleTypes
        ? _c(
            "v-menu",
            {
              staticClass: "profile-option-menu",
              attrs: {
                attach: "body",
                transition: "slide-y-transition",
                "close-on-click": "",
                "close-on-content-click": "",
                "open-on-hover": !_vm.isMobile,
                bottom: ""
              },
              model: {
                value: _vm.subProfileIsOpen,
                callback: function($$v) {
                  _vm.subProfileIsOpen = $$v
                },
                expression: "subProfileIsOpen"
              }
            },
            [
              _c(
                "v-btn",
                {
                  staticClass: "profile-menu-activator",
                  attrs: { slot: "activator", icon: "" },
                  slot: "activator"
                },
                [_c("v-icon", [_vm._v("keyboard_arrow_down")])],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list",
                { staticStyle: { background: "white" }, attrs: { light: "" } },
                [
                  _vm._l(_vm.profile.vehicleTypes, function(
                    vehicleType,
                    index
                  ) {
                    return [
                      _c(
                        "v-list-tile",
                        {
                          key: index,
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.profileSelected(
                                _vm.profile.slug,
                                vehicleType
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "v-list-tile-title",
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.getProfileTitle(
                                      _vm.profile.slug,
                                      vehicleType
                                    )
                                  ) +
                                  "\n            "
                              ),
                              _vm.activeVehicleType === vehicleType
                                ? _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        color: "primary",
                                        small: "",
                                        large: ""
                                      }
                                    },
                                    [_vm._v("check")]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  })
                ],
                2
              )
            ],
            1
          )
        : _vm.profile.nestedProfiles
        ? _c(
            "v-menu",
            {
              staticClass: "profile-option-menu",
              attrs: {
                attach: "body",
                transition: "slide-y-transition",
                "close-on-click": "",
                "close-on-content-click": "",
                "open-on-hover": !_vm.isMobile,
                bottom: ""
              },
              model: {
                value: _vm.subProfileIsOpen,
                callback: function($$v) {
                  _vm.subProfileIsOpen = $$v
                },
                expression: "subProfileIsOpen"
              }
            },
            [
              _c(
                "v-btn",
                {
                  staticClass: "profile-menu-activator",
                  attrs: { slot: "activator", icon: "" },
                  slot: "activator"
                },
                [_c("v-icon", [_vm._v("keyboard_arrow_down")])],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list",
                { staticStyle: { background: "white" }, attrs: { light: "" } },
                [
                  _vm._l(_vm.profile.nestedProfiles, function(
                    nestedProfile,
                    index
                  ) {
                    return [
                      _c(
                        "v-list-tile",
                        {
                          key: index,
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.profileSelected(nestedProfile)
                            }
                          }
                        },
                        [
                          _c(
                            "v-list-tile-title",
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.getProfileTitle(nestedProfile)) +
                                  "\n            "
                              ),
                              nestedProfile === _vm.activeProfileSlug
                                ? _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        color: "primary",
                                        small: "",
                                        large: ""
                                      }
                                    },
                                    [_vm._v("check")]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  })
                ],
                2
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-beedacea", { render: render, staticRenderFns: staticRenderFns })
  }
}